module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/particular01-856e11748f0457a7a309cee1040e8467.png";